import { CollectionItem } from '@aipb/personal-content/shared/model';
import { getCollectionLabel } from '@aipb/personal-content/shared/util';
import { ImageComponent } from '@aipb/ui/image';

import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';
import { UntilDestroy } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
  selector: 'pc-shared-collection-label',
  templateUrl: './collection-label.component.html',
  styleUrls: ['./collection-label.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ImageComponent, TranslocoModule]
})
export class CollectionLabelComponent {
  collection = input<CollectionItem>();

  label = computed(() => {
    const collection = this.collection();

    // @ts-expect-error foo
    return getCollectionLabel(collection);
  });
}
